import { Box } from 'portal-commons';
import React, { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  faTrash,
  faDna,
  faPen,
  faCopy,
  faEye,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableRow, TableCell } from '@material-ui/core';

import ApiKeyActionDialog from './ApiKeyActionDialog';
import CloneApiKeyModal from './CloneApiKeyModal';
import EditApiKeyModal from './EditApiKeyModal';
import { CustomSwitch, CustomTooltip } from '@/shared_elements';
import { toastFlashMessage } from '@/utils';
import { globalPutService } from '@/utils/globalApiServices';
import { convertTimeWithTimezone } from '@/utils/time';

const SCENE = {
  Edit: 'edit',
  Clone: 'clone',
  Delete: 'delete',
  CloneResult: 'cloneResult',
};

export default function ApiKeyListingRow(props) {
  const { accountObj } = props;
  const [account, setAccount] = useState(accountObj ? accountObj : {});
  const [scene, setScene] = useState(null);
  const [cloneResult, setCloneResult] = useState();

  const updateStatus = (status) => {
    const formdata = {
      enabled: status,
    };
    globalPutService(`mno/api/account/${account.id}`, formdata).then(
      (response) => {
        if (response.status >= 200 && response.status < 300) {
          toastFlashMessage(`API Key updated successfully`, 'success');
          setAccount(response.data);
        }
      }
    );
  };

  useEffect(() => {
    setAccount(accountObj);
  }, [accountObj]);

  return (
    <React.Fragment>
      <TableRow data-testid="apiKeyListingRow">
        <TableCell style={{ width: '41.3%' }}>
          {account.displayName ? account.displayName : '--'}
        </TableCell>
        <TableCell style={{ width: '8.3%' }}>
          <Box
            flexDirection="row"
            className="api-key-wrapper"
            data-testid="apiKeyListingRowApiKey"
            style={{ gap: '15px' }}
          >
            <CustomTooltip
              arrow
              title={
                <p>
                  API KEY <br /> {account.apiKey}
                </p>
              }
              placement="top"
            >
              <div className="img-wrapper view">
                <FontAwesomeIcon icon={faEye} />
              </div>
            </CustomTooltip>
            <CopyToClipboard
              text={account.apiKey}
              onCopy={() =>
                toastFlashMessage(
                  'API Key has been copied to your clipboard',
                  'success'
                )
              }
            >
              <CustomTooltip
                arrow
                placement="top"
                title={<div className="tooltip-content">Copy</div>}
              >
                <div className="img-wrapper copy">
                  <FontAwesomeIcon icon={faCopy} />
                </div>
              </CustomTooltip>
            </CopyToClipboard>
          </Box>
        </TableCell>
        <TableCell
          style={{ width: '25%' }}
          data-testid="apiKeyListingRowCreateDate"
        >
          {convertTimeWithTimezone(account.createDate)}
        </TableCell>
        <TableCell
          style={{ width: '8.3%', padding: '8px' }}
          data-testid="apiKeyListingRowCustomSwitch"
        >
          <CustomSwitch
            val={account.enabled ? true : false}
            handleChange={() => updateStatus(!account.enabled)}
          />
        </TableCell>
        <TableCell>
          <Box
            flexDirection="row"
            className="actions-wrapper"
            data-testid="apiKeyListingRowEditButton"
            style={{ gap: '17px' }}
          >
            <CustomTooltip
              arrow
              title={<div className="tooltip-content">Edit</div>}
              placement="top"
            >
              <div className="img-wrapper" onClick={() => setScene(SCENE.Edit)}>
                <FontAwesomeIcon icon={faPen} />
              </div>
            </CustomTooltip>
            <CustomTooltip
              arrow
              title={<div className="tooltip-content">Clone</div>}
              placement="top"
            >
              <div
                className="img-wrapper clone"
                onClick={() => setScene(SCENE.Clone)}
              >
                <FontAwesomeIcon icon={faDna} />
              </div>
            </CustomTooltip>
            <CustomTooltip
              arrow
              title={<div className="tooltip-content">Delete</div>}
              placement="top"
            >
              <div
                className="img-wrapper delete"
                onClick={() => setScene(SCENE.Delete)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </div>
            </CustomTooltip>
          </Box>
        </TableCell>
      </TableRow>
      {!!scene && [SCENE.Clone, SCENE.Delete].includes(scene) ? (
        <ApiKeyActionDialog
          type={scene}
          handleClose={() => setScene(null)}
          account={account}
          fetchApiAccounts={props.fetchApiAccounts}
          onCloneComplete={(account) => {
            setCloneResult(account);
            setScene(SCENE.CloneResult);
          }}
        />
      ) : null}
      <EditApiKeyModal
        open={scene === SCENE.Edit}
        account={account}
        onCancel={() => setScene(null)}
        onSave={(account) => {
          setAccount(account);
          setScene(null);
        }}
      />
      <CloneApiKeyModal
        open={scene === SCENE.CloneResult}
        account={cloneResult}
        onClose={() => setScene(null)}
      />
    </React.Fragment>
  );
}
